if (!customElements.get('price-range')) {
    customElements.define('price-range', class PriceRange extends HTMLElement {
      constructor() {
        super();
        this.rangeInput = document.querySelectorAll(".range-input input");
        this.priceInput = document.querySelectorAll(".price-input input");
        this.range = document.querySelector(".price_slider .progress");
        this.priceGap = 10;

        this.initialize();     
      }

      changeProgress(event){
            let minVal = parseInt(this.rangeInput[0].value),
                maxVal = parseInt(this.rangeInput[1].value);
                this.priceGap = parseInt(this.rangeInput[1].max) / 10;
                if ((maxVal - minVal) < this.priceGap) {
                    if (event.target.className === "range-min") {
                        this.rangeInput[0].value = maxVal - this.priceGap
                    } else {
                        this.rangeInput[1].value = minVal + this.priceGap;
                    }
                } else {
                    this.priceInput[0].value = minVal;
                    this.priceInput[1].value = maxVal;
                    this.range.style.left = ((minVal / this.rangeInput[0].max) * 100) + "%";
                    this.range.style.right = 100 - (maxVal / this.rangeInput[1].max) * 100 + "%";
                }
      }
      changeInput(event){
        let minVal = parseInt(this.rangeInput[0].value),
            maxVal = parseInt(this.rangeInput[1].value);
        console.log(minVal, maxVal);
        this.priceGap = parseInt(this.rangeInput[1].max) / 10;
        if ((maxVal - minVal) < this.priceGap) {
            if (event.target.className === "range-min") {
                this.rangeInput[0].value = maxVal - this.priceGap
            } else {
                this.rangeInput[1].value = minVal + this.priceGap;
            }
        } else {
            this.priceInput[0].value = minVal;
            this.priceInput[1].value = maxVal;
            this.range.style.left = ((minVal / this.rangeInput[0].max) * 100) + "%";
            this.range.style.right = 100 - (maxVal / this.rangeInput[1].max) * 100 + "%";
        }
      }

       initialRun(){
        let minVal = parseInt(this.priceInput[0].value),
            maxVal = parseInt(this.priceInput[1].value);
            
            if(minVal){
                this.rangeInput[0].value = minVal;
                this.range.style.left = ((minVal / this.rangeInput[0].max) * 100) + "%";
            }
            if(maxVal){
                this.rangeInput[1].value = maxVal;
                this.range.style.right = 100 - (maxVal / this.rangeInput[1].max) * 100 + "%";
            }
            
      } 

      initialize() {

        this.initialRun();
        
        this.priceInput.forEach(input => {
            input.addEventListener("input", e => this.changeInput(e));
        });

        this.rangeInput.forEach(input => {
            input.addEventListener("input", e => this.changeProgress(e));
        });
      }

      
    });
  }
  
  


/* const rangeInput = document.querySelectorAll(".range-input input"),
priceInput = document.querySelectorAll(".price-input input"),
range = document.querySelector(".price_slider .progress");
let priceGap = 10;
priceInput.forEach(input =>{
    
    input.addEventListener("input", e =>{
        let minPrice = parseInt(priceInput[0].value),
        maxPrice = parseInt(priceInput[1].value);
        console.log(minPrice,maxPrice);
        if((maxPrice - minPrice >= priceGap) && maxPrice <= rangeInput[1].max){
            if(e.target.className === "input-min"){
                rangeInput[0].value = minPrice;
                range.style.left = ((minPrice / rangeInput[0].max) * 100) + "%";
            }else{
                rangeInput[1].value = maxPrice;
                range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
            }
        }
    });
});
rangeInput.forEach(input =>{
    input.addEventListener("input", e =>{
        let minVal = parseInt(rangeInput[0].value),
        maxVal = parseInt(rangeInput[1].value);
        console.log(minVal,maxVal);
        priceGap = parseInt(rangeInput[1].max) / 10;
        if((maxVal - minVal) < priceGap){
            if(e.target.className === "range-min"){
                rangeInput[0].value = maxVal - priceGap
            }else{
                rangeInput[1].value = minVal + priceGap;
            }
        }else{
            priceInput[0].value = minVal;
            priceInput[1].value = maxVal;
            range.style.left = ((minVal / rangeInput[0].max) * 100) + "%";
            range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";
        }
    });
}); */